import { Crud } from ".";
import { getFromParam, getSearchParam, getToParam, getUserRoleParam } from "../hooks/paramsHelpers";

export class AdverStatApi extends Crud {
    constructor() {
        super('adver_stat')
    }
    async getUniqTopTable(listContext, extra) {
        listContext = JSON.parse(JSON.stringify(listContext));
        listContext.filter = {
            from: getFromParam(),
            to: getToParam(),
            // search: getSearchParam(),
            // role: getUserRoleParam(),
        }
        return await super.get(listContext, extra, "getUniqTopTable");
    }
}
